<script setup>
import {computed, onMounted, ref} from "vue";
import Button from "../../components/forms/Button.vue";
import {useRouter} from "vue-router";
import {formatDate, showSuccessMessage} from "../../helper";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {getLoggedUser} from "@/services/AuthService";
import ContractTypeService from "@/services/ContractTypeService";
import DocumentTemplateService from "@/services/DocumentTemplateService";
import CreateUpdateContractTypeModal from "@/components/modals/CreateUpdateContractTypeModal.vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
const router = useRouter();
const contractTypeId = router.currentRoute.value.params.id;
const contractType = ref({});
const isLoading = ref(true);
const isEditable = ref(false);
const documentTemplates = ref([]);

const signingRequiredDocumentTemplateNames = computed(() => {
  const ids = contractType.value.signing_required_document_template_ids ?? [];
  return documentTemplates.value
      .filter(template => ids.includes(template.id))
      .map(template => template.name);
});

onMounted(() => {
  fetchContractType();
  DocumentTemplateService.getAllActive().then((response) => {
    documentTemplates.value = response;
  });
  getLoggedUser().then(response => {
    let loggedUser = response;
    if(loggedUser.role === 'ADMIN' || loggedUser.role === 'SUPERADMIN' || loggedUser.role === 'BACK_OFFICE') {
      isEditable.value = true;
    }
  });
});

function fetchContractType() {
  isLoading.value = true;
  ContractTypeService.getContractType(contractTypeId).then((response) => {
    contractType.value = response;
    isLoading.value = false;
  });
}

function updateContractType() {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateContractTypeModal, contractType.value ? {
    contractType: contractType.value,
  } : {});
  reveal();
  onConfirm((data) => {
    ContractTypeService.saveContractType(data, contractTypeId).then(response => {
      showSuccessMessage(response.message);
      //fetchClients();
      contractType.value = response.contractType;
      //fetchDocumentTemplates(datatable.body);
    });
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-4">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> Zpět</a>
        </div>
        <div class="col-4 text-center">
          <div class="page-section__title">
            {{ t('contractTypesDetail.contract_type_detail') }}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
        </div>
      </div>

    </div>
    <div class="page-section__content">
      <div class="mb-4">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col">
                    <div class="card-header__title">
                      {{ t('contractTypesDetail.basic_info') }}
                    </div>
                  </div>
                  <div class="col text-end">
                    <div class="card-header__action">
                      <Button v-if="isEditable" :label="t('contractTypesDetail.edit')" @click="updateContractType()"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="info-table">
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">{{ t('contractTypesDetail.name') }}</span>
                    <span class="info-table__value col-12">{{ contractType.name }}</span>
                  </div>
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">{{ t('contractTypesDetail.description') }}</span>
                    <span class="info-table__value col-12">{{ contractType.description ?? '---' }}</span>
                  </div>
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">{{ t('contractTypesDetail.abbreviation') }}</span>
                    <span class="info-table__value col-12">{{ contractType.abbreviation ?? '---' }}</span>
                  </div>
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">{{ t('contractTypesDetail.signing_required_document_templates') }}</span>
                    <span class="info-table__value col-12">{{ signingRequiredDocumentTemplateNames.length ? signingRequiredDocumentTemplateNames.join(', ') : t('contractTypesDetail.no_signing_required_document_templates') }}</span>
                  </div>
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">{{ t('contractTypesDetail.active') }}</span>
                    <span class="info-table__value col-12">{{ contractType.is_active_new_contract ? t('contractTypesDetail.yes') : t('contractTypesDetail.no') }}</span>
                  </div>
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">Aktivní pro přidávání nových produktů:</span>
                    <span class="info-table__value col-12">{{ contractType.is_active_new_products ? 'Ano' : 'Ne' }} {{ contractType.is_active_new_products_from || contractType.is_active_new_products_from ? '(' + (contractType.is_active_new_products_from ? 'Od: ' + formatDate(contractType.is_active_new_products_from, 'd.m.Y H:i')  + ', ' : '') + (contractType.is_active_new_products_to ? 'Do: ' + formatDate(contractType.is_active_new_products_to, 'd.m.Y H:i') + ')' : '') : ''}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
